import konyveloApi from '@/api/konyveloApi'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUnauthMessage } from './useUnauthMessage'

export const useUser = defineStore('user', () => {
  const userData = ref<any>(null)

  // opcionálisan használható flag, hogy tudjuk figyelni, kell-e még várni a backendről jövő adatra
  const waitForData = ref<boolean>(false)

  function setUserData(data: any) {
    userData.value = data
    waitForData.value = false
  }

   async function fetchAndGetUser() {
      if (userData.value) return userData.value;
      try {
          const { data } = await konyveloApi.self()
          userData.value = data;
          return userData.value;
      } catch (err: any){
        // Ha le van tiltva a user, máshogy kezeljük
        if (err.response?.status == 403){
          throw new Error(`Letiltott felhasználó`);
        }
        else{
          userData.value = null;
          return null;
        }
      }
  }

  function setWaitForData(value: boolean){
    waitForData.value = value;
  }

  function clear() {
    userData.value = null
  }

  return { userData, waitForData, setUserData, setWaitForData, clear, fetchAndGetUser }
})
